import { render, staticRenderFns } from "./GroupStatisticTemplateCreate.vue?vue&type=template&id=0cfe8006"
import script from "./GroupStatisticTemplateCreate.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports